// extracted by mini-css-extract-plugin
export default {"root":"share-links_root__ebVZO","text":"share-links_text__2RB6V","list":"share-links_list__E5wl7","link":"share-links_link__wRi20"};